export default __webpack_public_path__ + "static/media/Hardware&Tools-banner.9e218c41.jpg";